import { render, staticRenderFns } from "./Type14a.vue?vue&type=template&id=5adca052&"
import script from "./Type14a.vue?vue&type=script&lang=js&"
export * from "./Type14a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports